import React, { Component } from 'react';

import { SearchResultItem } from '../../src/models/SearchResult';
import Translations from '../../src/models/Translations';

type SearchResultDescriptionProps = {
    count: number,
    translations: Translations,
    keywords: string,
}

type SearchResultDescriptionState = {
}

export default class SearchResultDescription extends Component<SearchResultDescriptionProps, SearchResultDescriptionState> {
    constructor(props: SearchResultDescriptionProps) {
        super(props);
        this.state = {
        };
    }

    public render() {
        let resultSentence: string, resultText: string;

        if (this.props.count == 0) {
            resultSentence = this.props.translations.result.noResultsSentence;
            resultText = this.props.translations.result.multipleResultsText;
        } else if (this.props.count == 1) {
            resultSentence = this.props.translations.result.singleResultSentence;
            resultText = this.props.translations.result.singleResultText;
        } else {
            resultSentence = this.props.translations.result.multipleResultsSentence;
            resultText = this.props.translations.result.multipleResultsText;
        }

        return (
            <React.Fragment>
                <h2 className="sr-only" aria-live="polite">
                    {
                        resultSentence
                            .replace('${amount}', `${this.props.count}`)
                            .replace('${result}', `${resultText}`)
                            .replace('${query}', `${this.props.keywords}`)
                    }
                </h2>
                <p className="pt-2" dangerouslySetInnerHTML={{
                    __html: resultSentence
                        .replace('${amount}', `<span class="font-weight-bold text-dark-red">${this.props.count}</span>`)
                        .replace('${result}', `<span class="font-weight-bold text-dark-red">${resultText}</span>`)
                        .replace('${query}', this.props.keywords)
                }}></p>
            </React.Fragment>
        );
    }
}